import { render, staticRenderFns } from "./AddBenefit.modal.vue?vue&type=template&id=6c954eb7&"
import script from "./AddBenefit.modal.vue?vue&type=script&lang=js&"
export * from "./AddBenefit.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports